import { getFeaturesProperties, trackEvent2 } from '@shared/statistics';
import { getGeorgeTheme } from '@shared/dark-mode';
import { getGatekeeperFeatures } from '@luna/gatekeeper';

export function trackGlobalProperties(): void {
    const { width, height, availWidth, availHeight } = window.screen;

    const featureProperties = getFeaturesProperties(getGatekeeperFeatures());

    trackEvent2('sessions', 'globalProperties', {
        screenResolutionWidth: width,
        screenResolutionHeight: height,
        availableScreenResolutionWidth: availWidth,
        availableScreenResolutionHeight: availHeight,
        theme: getGeorgeTheme(),
        ...featureProperties,
    });
}
